import { createApi } from '@reduxjs/toolkit/query/react';
import dayjs from 'dayjs';

import { DateFormat } from 'utils/date';
import { baseQueryWithReauth } from 'utils/services';

import {
  ChangeOrdersStatusReqProps,
  ChangeOrdersStatusResProps,
  GetAshOrdersDataItemProps,
  GetAshOrdersResProps,
  GetOrderReqProps,
  GetOrderResProps,
  GetOrdersReqProps,
  GetOrdersResProps,
  GroupedOrdersItemProps,
  TransformedOrdersData
} from './orders.types';

export const ordersApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    changeOrdersStatus: build.mutation<ChangeOrdersStatusResProps, ChangeOrdersStatusReqProps>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/orders/change-status'
      })
    }),
    getAshOrders: build.query<GetAshOrdersDataItemProps[], void>({
      query: () => '/orders/labs',
      transformResponse: (response: GetAshOrdersResProps) => response.data
    }),
    getOrder: build.query<GetOrderResProps, GetOrderReqProps>({
      query: (params) => ({
        method: 'GET',
        params,
        responseHandler: (response: Response) => response.blob().then((res) => res),
        url: '/orders/details'
      })
    }),
    getOrders: build.query<TransformedOrdersData, GetOrdersReqProps>({
      query: () => '/orders',
      transformResponse: (response: GetOrdersResProps): TransformedOrdersData => {
        const result: GroupedOrdersItemProps[] = [];
        response.data.forEach((item) => {
          const dateStr = dayjs(item.signedDate).format(DateFormat.MMM_DD);
          const existing = result.find(({ date }) => date === dateStr);
          if (existing) {
            existing.items.push(item);
          } else {
            result.push({ date: dateStr, items: [item] });
          }
        });
        return { orders: result, totalItems: response.data.length };
      }
    })
  }),
  reducerPath: 'ordersApi',
  tagTypes: ['Orders']
});

export const {
  useChangeOrdersStatusMutation,
  useGetAshOrdersQuery,
  useGetOrdersQuery,
  useLazyGetOrderQuery,
  useLazyGetOrdersQuery
} = ordersApi;
